<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>首页配置</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="form-wrapper">
         <el-form label-width="80px" :model="formData" :rules="formRules" ref="formRef">
            <el-form-item label="类型">
               <el-select v-model="formData.type" :disabled="actionType !== 'add'">
                  <el-option label="首页气泡" :value="1"></el-option>
                  <el-option label="首页通知栏" :value="2"></el-option>
                  <el-option label="首页顶部入口背景" :value="3"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="名称" prop="name">
               <el-input placeholder="最多20个字" :maxlength="20" v-model="formData.name"
                  :disabled="actionType === 'detail'">
               </el-input>
            </el-form-item>

            <div v-if="formData.type == 1">
               <el-form-item label="图形" prop="bubbleImage">
                  <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=4" tips="支持jpg、png"
                     :urls="formData.bubbleImage" :readonly="actionType === 'detail'" @onUrls="bubbleImageUploaded">
                  </UploadImage>
               </el-form-item>
               <el-form-item label="跳转链接" prop="url">
                  <el-input v-model="formData.url" :disabled="actionType === 'detail'"></el-input>
               </el-form-item>
            </div>

            <div v-if="formData.type == 2">
               <el-form-item label="标题图片" prop="titleImage">
                  <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=4" tips="支持jpg、png"
                     :urls="formData.titleImage" :readonly="actionType === 'detail'" @onUrls="titleImageUploaded">
                  </UploadImage>
               </el-form-item>
               <el-form-item label="文案" prop="copywriting">
                  <div class="flex-row margin-bottom-20">
                     <div style="width: 40px;">内容</div>
                     <el-input placeholder="最多15个字" :maxlength="15" v-model="formData.content"
                        :disabled="actionType === 'detail'">
                     </el-input>
                  </div>
                  <div class="flex-row">
                     <div style="width: 40px;">指引</div>
                     <el-input placeholder="最多4个字" :maxlength="4" v-model="formData.guide"
                        :disabled="actionType === 'detail'">
                     </el-input>
                  </div>
               </el-form-item>
               <el-form-item label="跳转链接" prop="url">
                  <el-input v-model="formData.url" :disabled="actionType === 'detail'"></el-input>
               </el-form-item>
            </div>

            <div v-if="formData.type == 3">
               <el-form-item label="图形" prop="backImage">
                  <div class="flex-row-between">
                     <div>
                        <div>我的奖牌背景</div>
                        <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=4"
                           tips="(尺寸:100px*88px,jpg、png)" :urls="formData.medalImage"
                           :readonly="actionType === 'detail'" @onUrls="medalImageUploaded">
                        </UploadImage>
                     </div>
                     <div>
                        <div>数字奖牌排名背景</div>
                        <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=4"
                           tips="(尺寸:100px*88px,jpg、png)" :urls="formData.rankingImage"
                           :readonly="actionType === 'detail'" @onUrls="rankingImageUploaded">
                        </UploadImage>
                     </div>
                  </div>
               </el-form-item>
            </div>

            <el-form-item label="有效时间" prop="effectiveTime">
               <div class="flex-row-between">
                  <el-date-picker placeholder="起始日期" type="datetime" v-model="formData.startTime"
                     :disabled="actionType === 'detail'">
                  </el-date-picker>
                  <div>至</div>
                  <el-date-picker placeholder="截止日期" type="datetime" v-model="formData.endTime"
                     :disabled="actionType === 'detail'">
                  </el-date-picker>
               </div>
            </el-form-item>
         </el-form>
      </div>

      <div class="margin-20" v-if="actionType !== 'detail'">
         <el-button type="primary" @click="clickSave">保存</el-button>
         <el-button type="primary" @click="clickSaveAndPublish">保存并发布</el-button>
      </div>
   </div>
</template>

<script>
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";

export default {
   components: {
      UploadImage
   },

   data() {
      // 验证入口背景图
      const validateBackImage = (rule, value, callback) => {
         if (!this.formData.medalImage || this.formData.medalImage === '') {
            callback(new Error('请选择奖牌背景图形'));
         } else if (!this.formData.rankingImage || this.formData.rankingImage === '') {
            callback(new Error('请选择奖牌排名背景图形'));
         } else {
            callback();
         }
      };
      // 验证文案
      const validateCopyWritting = (rule, value, callback) => {
         if (!this.formData.content || this.formData.content === '') {
            callback(new Error('请输入内容'));
         } else if (!this.formData.guide || this.formData.guide === '') {
            callback(new Error('请输入指引'));
         } else {
            callback();
         }
      };
      // 验证有效日期
      const validateEffectiveTime = (rule, value, callback) => {
         if (!this.formData.startTime || this.formData.startTime === '') {
            callback(new Error('请选择起始日期'));
         } else if (!this.formData.endTime || this.formData.endTime === '') {
            callback(new Error('请选择截止日期'));
         } else {
            const startDate = new Date(this.formData.startTime);
            const endDate = new Date(this.formData.endTime);
            if (startDate.getTime() >= endDate.getTime()) {
               callback(new Error('起始日期不能大于截止日期'));
            } else {
               callback();
            }
         }
      };
      return {
         loading: false,
         actionType: '',
         id: '',
         formData: {
            type: 1,
            name: '',
            bubbleImage: '',
            titleImage: '',
            medalImage: '',
            rankingImage: '',
            content: '',
            guide: '',
            url: '',
            startTime: '',
            endTime: '',
            status: '',
         },
         formRules: {
            name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
            bubbleImage: [{ required: true, message: '请选择图片', trigger: 'blur' }],
            titleImage: [{ required: true, message: '请选择图片', trigger: 'blur' }],
            backImage: [{ required: true, validator: validateBackImage, trigger: 'blur' }],
            copywriting: [{ required: true, validator: validateCopyWritting, trigger: 'blur' }],
            url: [{ required: true, message: '请输入链接', trigger: 'blur' }],
            effectiveTime: [{ required: true, validator: validateEffectiveTime, trigger: 'blur' }],
         },
      }
   },

   mounted() {
      this.actionType = this.$route.query.actionType || '';
      this.id = this.$route.query.id || '';
      this.formData.type = this.$route.query.type || 1;
      if (this.id !== '') {
         this.queryInfo(this.id);
      }
   },

   methods: {
      // 查询信息
      queryInfo(id) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/home/config/detail',
            method: 'GET',
            params: { id }
         }).then((res) => {
            if (res.data.error !== 10000) {
               this.$util.errorMsg(res.data.message);
               return;
            }
            const info = res.data.data;
            this.formData.name = info.name;
            this.formData.url = info.url;
            this.formData.startTime = info.startTime ? new Date(info.startTime) : '';
            this.formData.endTime = info.endTime ? new Date(info.endTime) : '';
            this.formData.status = info.status;
            if (info.copyWriter && info.copyWriter.length > 0) {
               const content = info.copyWriter.find((item) => item.type === 2);
               this.formData.content = content ? content.content : '';
               const guide = info.copyWriter.find((item) => item.type === 3);
               this.formData.guide = guide ? guide.content : '';
            }
            if (info.pictures && info.pictures.length > 0) {
               if (info.type === 1) {
                  this.formData.bubbleImage = info.pictures[0].url;
               } else if (info.type === 2) {
                  this.formData.titleImage = info.pictures[0].url;
               } else if (info.type === 3) {
                  const rankingImage = info.pictures.find((item) => item.type === 0);
                  this.formData.rankingImage = rankingImage ? rankingImage.url : '';
                  const medalImage = info.pictures.find((item) => item.type === 1);
                  this.formData.medalImage = medalImage ? medalImage.url : '';
               }
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送配置
      sendConfig(status) {
         let param = {
            type: this.formData.type,
            name: this.formData.name,
            url: this.formData.url,
            startTime: new Date(this.formData.startTime).format('yyyy-MM-dd hh:mm:ss'),
            endTime: new Date(this.formData.endTime).format('yyyy-MM-dd hh:mm:ss'),
            status: status,
         };
         if (this.id && this.id !== '') {
            param['id'] = this.id;
         }
         if (this.formData.type == 1) {
            param['pictures'] = [{ type: 0, url: this.formData.bubbleImage }];
         } else if (this.formData.type == 2) {
            param['pictures'] = [{ type: 0, url: this.formData.titleImage }];
            param['copyWriter'] = [
               { type: 1, content: '' },
               { type: 2, content: this.formData.content },
               { type: 3, content: this.formData.guide },
            ];
         } else if (this.formData.type == 3) {
            param['pictures'] = [
               { type: 0, url: this.formData.rankingImage },
               { type: 1, url: this.formData.medalImage },
            ];
         }
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/home/config/addOrEdit',
            method: 'POST',
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error === 10000) {
               this.$router.go(-1);
               this.$util.successMsg(res.data.message);
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 上传气泡图形图片
      bubbleImageUploaded(image) {
         this.formData.bubbleImage = image;
      },
      // 上传通知栏标题图片
      titleImageUploaded(image) {
         this.formData.titleImage = image;
      },
      // 上传奖牌背景图片
      medalImageUploaded(image) {
         this.formData.medalImage = image;
      },
      // 上传奖牌排名背景图片
      rankingImageUploaded(image) {
         this.formData.rankingImage = image;
      },
      // 点击保存
      clickSave() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               this.sendConfig(1);
            }
         });
      },
      // 点击保存并发布
      clickSaveAndPublish() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               this.sendConfig(2);
            }
         });
      },
   },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// HomeConfigAddition.vue?92aef736